import { inject, Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { SIMULATE_ALL_FAILURES } from '../../constants/demo.config';

/**
 * Shared failure simulator for the demo services.
 *
 * Lives on its own rather than inside a demo service because both pipelines
 * need it and TypeScript gives each of them a different base class, so it
 * cannot be inherited. Injecting it also means the two demos share one
 * "already failed" set: navigating resets it once, not twice.
 */
@Injectable({ providedIn: 'root' })
export class DemoFailures {
  private readonly failed = new Set<string>();

  constructor() {
    // Reset on every navigation so the first call of each page fails again.
    inject(Router).events.subscribe(e => {
      if (e instanceof NavigationStart) this.failed.clear();
    });
  }

  /** True the first time this key is seen, false after. Use directly to break
   *  one specific call without turning on SIMULATE_ALL_FAILURES. */
  once(key: string): boolean {
    if (this.failed.has(key)) return false;
    this.failed.add(key);
    return true;
  }

  /** True only when the global switch is on, and only on the first attempt. */
  should(key: string): boolean {
    return SIMULATE_ALL_FAILURES && this.once(key);
  }
}
